import { render } from "./Commande_Inscription_Item.vue?vue&type=template&id=a4d90e54"
import script from "./Commande_Inscription_Item.vue?vue&type=script&lang=js"
export * from "./Commande_Inscription_Item.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__